import {useTranslation} from "react-i18next";
import {useState} from "react";

import OrderByHeaders from "components/ordering/OrderByHeaders";
import IconBool from "components/IconBool";
import DateDisplay from "components/datetime/DateDisplay";

const TableRoutesMooch = ({items, itemsShown, setItemsShown, buttonsTB, setButtonsTB, orderingRef}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _tT} = useTranslation("tags");

    const [checkAll, setCheckAll] = useState(false);
    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        const id = parseInt(e.currentTarget.dataset.idx);
        if (checkbox.checked) {
            items.current.addToChosen(id);
        } else {
            items.current.removeFromChosen(id);
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShown.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length === 0;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th className="sticky-top border-bottom-sticky" key="-1" style={{width: "30px", ...stickyHeaderStyle}}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShown.map((item, index) => (
                    <tr key={item.id} data-idx={item.id} onClick={onClick} className="cursor-pointer">
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td>
                            <DateDisplay date={item.mooched_at} format="DD-MM-YYYY HH:mm" title={true} />
                        </td>
                        <td>{item.island_data.name}</td>
                        <td>{item.island_data.zone || ""}</td>
                        <td>{(item.route_data && item.route_data.driver) || ""}</td>
                        <td>{(item.route_data && item.route_data.name) || ""}</td>
                        <td className="text-center">
                            <IconBool value={item.cleared} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableRoutesMooch;
